module.exports = __webpack_public_path__ + "static/media/maragogi-partitura.507e9eda.png";